// components/ContactCard.js
import React, { useState } from "react";

const colors = {
  mainBlue: "#061941",
  cafeNoir: "#583E23",
  carrieban: "#3C6E71",
  isabelline: "#F4F3EE",
  gold: "#F2AF29"
};

export default function ContactCard({ option, isVisible, onFeedbackClick }) {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (option.type === "feedback" && onFeedbackClick) {
      onFeedbackClick();
    } else if (option.email) {
      window.location.href = `mailto:${option.email}`;
    }
  };

  return (
    <div
      style={{
        flex: "1 1 350px",
        maxWidth: "400px",
        minWidth: "300px",
        backgroundColor: colors.isabelline,
        borderRadius: "12px",
        padding: "2.5rem 2rem",
        textAlign: "center",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        height: "600px",
        transform: isVisible
          ? (isHovered ? "translateY(-8px) scale(1.02)" : "translateY(0) scale(1)")
          : "translateY(30px) scale(0.95)",
        opacity: isVisible ? 1 : 0,
        transition: "all 0.4s ease-out",
        boxShadow: isHovered
          ? `0 12px 30px rgba(0, 0, 0, 0.15), 0 0 0 2px ${colors.gold}40`
          : "0 6px 20px rgba(0, 0, 0, 0.1)",
        border: `2px solid ${isHovered ? colors.gold : 'transparent'}`
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      {/* Icon */}
      <div
        style={{
          fontSize: "3rem",
          marginBottom: "1.5rem",
          filter: isHovered ? "brightness(1.1)" : "brightness(1)",
          transition: "filter 0.3s ease"
        }}
      >
        {option.icon}
      </div>

      {/* Title */}
      <h2
        style={{
          fontFamily: "Poppins, Segoe UI, Arial, sans-serif",
          fontSize: "1.8rem",
          fontWeight: 700,
          color: colors.mainBlue,
          margin: "0 0 1rem 0"
        }}
      >
        {option.title}
      </h2>

      {/* Email or Action Button */}
      <div
        style={{
          backgroundColor: colors.gold,
          color: colors.mainBlue,
          padding: "0.8rem 1.5rem",
          borderRadius: "25px",
          fontSize: "1rem",
          fontWeight: 600,
          margin: "0 0 1.5rem 0",
          display: "inline-block",
          transform: isHovered ? "scale(1.05)" : "scale(1)",
          transition: "transform 0.3s ease"
        }}
      >
        {option.type === "feedback" ? "Share Your Feedback" : option.email}
      </div>

      {/* Description */}
      <p
        style={{
          fontSize: "0.95rem",
          color: colors.mainBlue,
          opacity: 0.8,
          lineHeight: 1.5,
          margin: "0 0 0.8rem 0"
        }}
      >
        {option.description}
      </p>

      {/* Availability */}
      <div
        style={{
          borderTop: `1px solid ${colors.mainBlue}20`,
          paddingTop: "1.2rem",
          marginTop: "auto",
          width: "100%",
          paddingBottom: "0.5rem"
        }}
      >
        <p
          style={{
            fontSize: "0.9rem",
            color: colors.mainBlue,
            opacity: 0.7,
            margin: "0 0 0.4rem 0",
            fontWeight: 600,
            textAlign: "center"
          }}
        >
          {option.availability}
        </p>
        <p
          style={{
            fontSize: "0.85rem",
            color: colors.mainBlue,
            opacity: 0.6,
            margin: 0,
            textAlign: "center"
          }}
        >
          {option.hours}
        </p>
      </div>




    </div>
  );
}